import { Outlet } from 'react-router-dom';
import { ConversationsProvider } from '@/context/ConversationsContext';
import { PrayerUnreadProvider } from '@/context/PrayerUnreadContext';
import { PollBadgesProvider } from '@/context/PollBadgesContext';
import NotificationsManager from '@/components/NotificationsManager';
import { ToastProvider } from '@/components/Toast';
import CapacityWindowBanner from '@/components/CapacityWindowBanner';
import FullLockTakeover from '@/components/lock/FullLockTakeover';
import { useOrgLockState } from '@/hooks/useOrgLockState';
import Sidebar from './Sidebar';

export default function AppShell() {
  const { allOrgsLocked } = useOrgLockState();

  // Every org paused: no healthy rail to fall back on — replace the whole shell.
  if (allOrgsLocked) {
    return <FullLockTakeover />;
  }

  return (
    <ConversationsProvider>
      <PrayerUnreadProvider>
        <PollBadgesProvider>
        <ToastProvider>
          <NotificationsManager />
          <div className="flex h-screen overflow-hidden bg-flock-navy-50">
            <Sidebar />
            <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
              <CapacityWindowBanner />
              <main className="min-h-0 flex-1 overflow-hidden">
                <Outlet />
              </main>
            </div>
          </div>
        </ToastProvider>
        </PollBadgesProvider>
      </PrayerUnreadProvider>
    </ConversationsProvider>
  );
}
